const path = require('path');
const configment = require('@adc/configment');
class InvalidProxyRouteError extends Error {
    constructor(endpoint) {
        super();
        this.message = `Cannot whitelist ${endpoint}. See @adc/fetch for more details.`;
    }
}
function hash(str) {
    var hash = 0;
    if (str.length === 0)
        return String(hash);
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    }
    return hash.toString(36);
}
const defaultProxyOptions = {
    excludeHeaders: ['Cookie'],
    token: 'any',
};
function generateProxyRoute(definition) {
    const basePrefix = configment.get('URL_BASE_PREFIX');
    let endpoint = '';
    let base = {};
    if (typeof definition === 'string') {
        endpoint = definition;
    }
    else {
        endpoint = definition.endpoint;
        base = definition;
    }
    if (!usesProxy(endpoint)) {
        throw new InvalidProxyRouteError(endpoint);
    }
    let url;
    try {
        url = new URL(endpoint);
    }
    catch (e) {
        throw new InvalidProxyRouteError(endpoint);
    }
    const maskedHost = url.host.replace(/(\d{1,3}\.\d{1,3}\.\d{1,3}\.)\d{1,3}(:\d{2,4})/, '$1XXX$2');
    return Object.assign({}, defaultProxyOptions, base, {
        route: path.join(basePrefix, '/cu/api', hash(maskedHost), url.pathname),
        endpoint,
    });
}
function usesProxy(route) {
    return !!(route.match(/http:\/\/localhost:\d{2,4}/) ||
        route.match(/http:\/\/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{2,4}/) ||
        route.match(/http:\/\/.*\.local:\d{4}/) ||
        route.match(/http:\/\/.*\.tenx_overlay:\d{4}/) ||
        route.match(/http:\/\/.*\.ten-x\.cloud(:\d{4})?/) ||
        route.match(/http:\/\/.*\.ten-x\.io:\d{4}/) ||
        route.match(/http:\/\/(.*)\.(.*)\.svc\.cluster\.local(:\d{2,4})?/) ||
        route.match(/http:\/\/(.*)\.(default|backend|app)(:\d{2,4})?/) ||
        route.match(/https:\/\/(service|api)\.(ci|qa|prod|produse2)\.aucn\.io(:\d{2,4})?/));
}
export { generateProxyRoute, usesProxy };
//# sourceMappingURL=proxyRoutes.js.map